<app-text-field
  #textField
  [required]="required"
  [index]="index"
  [errorTexts]="errorTexts"
  [validateOnDirty]="validateOnDirty"
  [readonly]="readonly"
  [label]="label"
  [showHideText]="showHideText"
  [inputType]="inputTypeModified"
  [isDisabled]="isDisabled$ | async"
  (valueChanges)="inputValue($event)"
>
  <button
    class="copy-button white mulish w-5 h-5 flex items-center justify-center relative"
    placement="top-right"
    tooltipClass="default-tooltip copy-tooltip"
    [ngbTooltip]="buildTranslationKey('copyTooltipText') | translate"
    [class.opacity-50]="isDisabled$ | async"
    (click)="copyText()"
  >
    @if (runCopyAnimation$ | async; as animationActive) {
      <app-success-animation
        [activateAnimation]="animationActive"
        [height]="'20px'"
        [width]="'20px'"
      ></app-success-animation>
    } @else {
      <svg-icon src="copy"></svg-icon>
    }
  </button>
</app-text-field>
